<template>
    <DsTooltip
        :closeDelay="100"
        :hideTooltipOnClick
        :openDelay="500"
        :tooltipLocation
        :tooltipText
    >
        <DsButton
            :aria-label="$attrs['aria-label'] || tooltipText"
            iconOnly
            :onDarkBg
            :size
            variant="icon"
            v-bind="$attrs"
        >
            <DsIcon
                class="align-middle"
                data-testid="ds-icon"
                :icon
                :size="iconSize"
                :spin
            />
        </DsButton>
    </DsTooltip>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';
import DsButton from '@ds/form/input/DsButton.vue';
import DsTooltip from '@ds/tooltip/DsTooltip.vue';
import type { FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';
import type { TooltipPlacementType } from './design-system';

export type IconButtonSize = 'md' | 'sm';

export interface DsIconButtonProps {
    icon: FontAwesomeIconProps['icon'];
    onDarkBg?: boolean;
    size: IconButtonSize;
    spin?: boolean;
    tooltipLocation?: TooltipPlacementType;
    tooltipText: string;
    hideTooltipOnClick?: boolean;
}

const props = withDefaults(defineProps<DsIconButtonProps>(), {
    onDarkBg: false,
    tooltipLocation: 'top',
    spin: false,
    hideTooltipOnClick: true,
});

const iconSize = computed(() => {
    return props.size === 'md' ? 'lg' : 'md';
});
</script>
